var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#D0103A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17C20 17.3536 19.8595 17.6928 19.6095 17.9428C19.3594 18.1929 19.0203 18.3333 18.6667 18.3333H10.6667L8 21V10.3333C8 9.97971 8.14048 9.64057 8.39052 9.39052C8.64057 9.14048 8.97971 9 9.33333 9H18.6667C19.0203 9 19.3594 9.14048 19.6095 9.39052C19.8595 9.64057 20 9.97971 20 10.3333V17Z",
    stroke: "#D0103A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportEmail);
export default __webpack_public_path__ + "static/media/SupportEmail.ef62de316f21980e583844034f330fc9.svg";
export { ForwardRef as ReactComponent };